module.exports = __webpack_public_path__ + "media/images/amenities_icons/yoga_studio-c0c0472122dd76cf68bbd33b9188f171.svg";